export const XIcon = () => {
  return <>✕</>;
};
